import { render, staticRenderFns } from "./StudentToTeacherPage.vue?vue&type=template&id=35f06c1c"
import script from "./StudentToTeacherPage.vue?vue&type=script&lang=ts"
export * from "./StudentToTeacherPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports